/* ============================================================
   SIMOVO Journal — article template behaviour (Direction A)
   - Parses bracket shortcodes writers type in the normal editor:
       [tip] [warning] [takeaways] [numbered] [faq] [esim] [caption]
     into styled blocks (no HTML needed by the writer).
   - Builds the table of contents from the body h2/h3 (+ scroll-spy)
   - FAQ accordion + auto FAQPage JSON-LD
   Native editor output (blockquote, table, images) is styled by CSS.
   ============================================================ */
(function () {
  "use strict";

  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c]; }); }
  function attrs(s) {
    var o = {};
    (s || "").replace(/(\w+)\s*=\s*"([^"]*)"/g, function (_, k, v) {
      // a translation/encoding tool can break a closing quote; never let the
      // captured value bleed into page markup — cut at the first tag start,
      // whether raw (<) or entity-encoded (&lt;).
      var cut = v.search(/<|&lt;|&#0*60;?/i);
      if (cut > -1) v = v.slice(0, cut);
      o[k] = v.trim();
    });
    return o;
  }
  function txt(inner) {
    return String(inner).replace(/<\/?p[^>]*>/gi, " ").replace(/<br\s*\/?>/gi, " ")
      .replace(/&nbsp;/gi, " ").replace(/\s+/g, " ").trim();
  }
  var PRE = "(?:<p>\\s*)?", POST = "(?:\\s*</p>)?";

  function parseShortcodes(root) {
    var body = root.querySelector("[data-svo-body]");
    if (!body) return;
    var html = body.innerHTML;

    html = html.replace(new RegExp(PRE + "\\[(tip|warning)([^\\]]*)\\]([\\s\\S]*?)\\[\\/\\1\\]" + POST, "gi"),
      function (_, kind, a, inner) {
        var o = attrs(a), title = o.title || (kind === "tip" ? "Pro tip" : "Heads up");
        var icon = kind === "tip" ? "\u2713" : "!";
        return '<div class="svo-callout svo-callout--' + kind + '"><span class="svo-callout__icon">' + icon +
          '</span><div><div class="svo-callout__title">' + esc(title) + '</div><p>' + txt(inner) + "</p></div></div>";
      });

    html = html.replace(new RegExp(PRE + "\\[takeaways([^\\]]*)\\]([\\s\\S]*?)\\[\\/takeaways\\]" + POST, "gi"),
      function (_, a, inner) {
        var o = attrs(a), label = o.title || "Key takeaways", lis = [], m, re = /<li[^>]*>([\s\S]*?)<\/li>/gi;
        // strip a leading bullet/dash the writer may have typed (the box adds its own tick)
        var debullet = function (s) { return String(s).replace(/^\s*(?:&bull;|&#8226;|&#x2022;|[\u2022\u00b7\u2023\u25e6\u2043\u2219\u2027*\u2010-\u2015-])\s+/, "").trim(); };
        while ((m = re.exec(inner))) lis.push(debullet(m[1].trim()));
        if (!lis.length) {
          inner.replace(/<\/?p[^>]*>/gi, "\n").split(/<br\s*\/?>|\n/).forEach(function (l) {
            var t = debullet(l.replace(/<[^>]+>/g, "").trim()); if (t) lis.push(t);
          });
        }
        return '<div class="svo-takeaways"><div class="svo-takeaways__label">' + esc(label) + "</div><ul>" +
          lis.map(function (li) { return "<li>" + li + "</li>"; }).join("") + "</ul></div>";
      });

    var nIdx = 0;
    html = html.replace(new RegExp(PRE + "\\[numbered([^\\]]*)\\]([\\s\\S]*?)\\[\\/numbered\\]" + POST, "gi"),
      function (_, a, inner) {
        nIdx++; var o = attrs(a);
        var idx = o.n || ("0" + nIdx).slice(-2);
        var pill = o.pill ? '<span class="svo-numbered__pill">' + esc(o.pill) + "</span>" : "";
        return '<div class="svo-numbered"><div class="svo-numbered__index">' + esc(idx) +
          '</div><div><div class="svo-numbered__head"><h3 class="svo-numbered__title">' + esc(o.title || "") + "</h3>" +
          pill + '</div><p>' + txt(inner) + "</p></div></div>";
      });

    html = html.replace(new RegExp(PRE + "\\[faq\\]([\\s\\S]*?)\\[\\/faq\\]" + POST, "gi"),
      function (_, inner) {
        var items = "", m, re = /\[q\]([\s\S]*?)\[\/q\][\s\S]*?\[a\]([\s\S]*?)\[\/a\]/gi;
        while ((m = re.exec(inner))) {
          items += '<div class="svo-faq__item"><button class="svo-faq__q" type="button">' + txt(m[1]) +
            '<span class="svo-faq__sign">+</span></button><div class="svo-faq__a"><p>' + txt(m[2]) + "</p></div></div>";
        }
        return '<div class="svo-faq">' + items + "</div>";
      });

    html = html.replace(new RegExp(PRE + "\\[esim([^\\]]*)\\]([\\s\\S]*?)\\[\\/esim\\]" + POST, "gi"),
      function (_, a, inner) {
        var o = attrs(a);
        var flag = o.flag ? '<span class="svo-esim__flag">' + o.flag + "</span>" : "";
        var label = o.label ? '<span class="svo-esim__label">eSIM for ' + esc(o.label) + "</span>" : "";
        var benefits = o.benefits || "Instant QR setup \u00b7 Reliable 4G/5G \u00b7 No contract";
        var buy = "";
        if (o.data || o.price) buy += '<div class="svo-esim__plan">' + (o.data ? '<div class="svo-esim__plan-sub">' + esc(o.data) + "</div>" : "") + (o.price ? '<div class="svo-esim__price">' + esc(o.price) + "</div>" : "") + "</div>";
        buy += '<a class="svo-esim__cta" href="' + esc(o.href || "#") + '">' + esc(o.cta || ("Shop " + (o.label || "") + " eSIMs")) + "</a>";
        return '<div class="svo-esim svo-esim--inline"><div class="svo-esim__copy"><div class="svo-esim__top">' +
          flag + label + '</div><h3 class="svo-esim__title">' + txt(inner) + '</h3><p>' + esc(benefits) +
          '</p></div><div class="svo-esim__buy">' + buy + "</div></div>";
      });

    html = html.replace(new RegExp(PRE + "\\[caption\\]([\\s\\S]*?)\\[\\/caption\\]" + POST, "gi"),
      function (_, inner) { return '<p class="svo-caption">' + txt(inner) + "</p>"; });

    body.innerHTML = html;
  }

  function slugify(s) {
    return String(s).toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-").slice(0, 60) || "section";
  }

  function buildTOC(root) {
    var body = root.querySelector("[data-svo-body]"), toc = root.querySelector("[data-svo-toc]"), card = root.querySelector("[data-svo-toc-card]");
    if (!body || !toc) return [];
    var heads = Array.prototype.slice.call(body.querySelectorAll("h2, h3")).filter(function (h) {
      return !h.closest(".svo-numbered, .svo-esim, .svo-callout, .svo-takeaways, .svo-faq");
    });
    if (!heads.length) { if (card) card.style.display = "none"; return []; }
    var used = {}, links = [];
    heads.forEach(function (h) {
      var id = h.id;
      if (!id) { id = slugify(h.textContent); while (used[id] || document.getElementById(id)) id += "-x"; h.id = id; }
      used[id] = true;
      var a = document.createElement("a");
      a.href = "#" + id; a.textContent = h.textContent;
      a.className = h.tagName === "H3" ? "lvl-3" : "lvl-2";
      a.setAttribute("data-target", id);
      toc.appendChild(a); links.push({ a: a, h: h });
    });
    return links;
  }

  function wireSmoothScroll(root, links) {
    function offset() { var v = getComputedStyle(root).getPropertyValue("--svo-article-anchor"); var n = parseInt(v, 10); return isNaN(n) ? 80 : n; }
    root.querySelectorAll("[data-svo-toc] a, .svo-article a[href^='#']").forEach(function (a) {
      a.addEventListener("click", function (e) {
        var id = a.getAttribute("href").slice(1), el = id && document.getElementById(id);
        if (!el) return;
        e.preventDefault();
        window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - offset(), behavior: "smooth" });
        history.replaceState(null, "", "#" + id);
      });
    });
    if (!links.length) return;
    var raf = null;
    function spy() {
      raf = null; var line = offset() + 12, cur = links[0];
      links.forEach(function (l) { if (l.h.getBoundingClientRect().top <= line) cur = l; });
      links.forEach(function (l) { l.a.classList.toggle("is-active", l === cur); });
    }
    window.addEventListener("scroll", function () { if (!raf) raf = requestAnimationFrame(spy); }, { passive: true });
    spy();
  }

  function wireFAQ(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll(".svo-faq__item")), qa = [];
    items.forEach(function (item) {
      var btn = item.querySelector(".svo-faq__q"), sign = item.querySelector(".svo-faq__sign"), ans = item.querySelector(".svo-faq__a");
      if (btn) btn.addEventListener("click", function () { var open = item.classList.toggle("is-open"); if (sign) sign.textContent = open ? "\u2013" : "+"; });
      if (btn && ans) { var q = btn.cloneNode(true); var s = q.querySelector(".svo-faq__sign"); if (s) s.remove(); qa.push({ q: q.textContent.trim(), a: ans.textContent.trim() }); }
    });
    if (qa.length && !root.__faqLd) {
      root.__faqLd = true;
      var ld = { "@context": "https://schema.org", "@type": "FAQPage", "mainEntity": qa.map(function (x) { return { "@type": "Question", "name": x.q, "acceptedAnswer": { "@type": "Answer", "text": x.a } }; }) };
      var sc = document.createElement("script"); sc.type = "application/ld+json"; sc.textContent = JSON.stringify(ld); document.head.appendChild(sc);
    }
  }

  function init(root) {
    if (!root || root.__svoArticle) return;
    root.__svoArticle = true;
    parseShortcodes(root);
    var links = buildTOC(root);
    wireSmoothScroll(root, links);
    wireFAQ(root);
  }

  function boot() { document.querySelectorAll(".svo-article[data-svo-root]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", function (e) {
    var r = e.target.querySelector ? e.target.querySelector(".svo-article[data-svo-root]") : null;
    if (r) { r.__svoArticle = false; init(r); }
  });
})();